import { render, staticRenderFns } from "./DemoRequest.vue?vue&type=template&id=ef06619a"
import script from "./DemoRequest.vue?vue&type=script&lang=js"
export * from "./DemoRequest.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports